<div class="episode-list">
  @for (eps of epList; track eps.id) {
    <div class="ui segment episode-card" [ngClass]="eps.labelClass + (toggleMap[eps.id] ? ' expanded' : '')">
      <div class="ep-no">{{eps.ep}}</div>
      <div class="title">{{eps.nameCn || eps.name}}</div>
      <div class="air-date">{{eps.publicTime | date:'yyyy-MM-dd' }}</div>
      <div class="duration">{{eps.properties['duration']?.value}}</div>
      <a class="expand-button anchor-button" (click)="toggleEps(eps)" [ngClass]="{disabled: !eps.desc}">
        <i class="angle icon" [ngClass]="{up: toggleMap[eps.id], down: !toggleMap[eps.id]}"></i>
      </a>
      @if (eps.desc) {
        <div class="expandable-content">
          {{eps.desc}}
        </div>
      }
    </div>
  }
</div>
<div class="sp-list">
  @for (eps of spList; track eps.id) {
    <a class="ui label" [ngClass]="eps.labelClass">{{eps.ep}}</a>
  }
</div>

